import { Box, Text, HStack, Flex } from "@chakra-ui/react";
import closeicon from "../../assets/kudzu-plus-images/Close-white.png";


const MembershipBanner = ({ handleExploreClick, handleCloseClick }) => {
    return (
        <Box
            className="w-full bg-[#1E2A3A] text-white fixed top-0 md:top-auto md:bottom-0 left-0 z-50 flex items-center h-[50px] md:h-[100px]"
            py={{ base: 3, md: 40 }}
            px={{ base: 4, md: 40 }}
             height={{ base: "auto", md: "100px" }}
        >
            <Flex
                className="w-full"
                align="center"
                justify="space-between"
                direction="row"
            >
                {/* Text on the left with margin-left only on desktop */}
                <Text
                    fontSize={{ base: "md", md: "lg" }}
                    className="mr-10 md:ml-10 text-gray-300 md:text-[22px] text-[14px]  text-center md:text-left"
                    fontFamily="'Source Serif Pro', serif"
                    flex="1"
                    ml={{ base: 2, md: 100 }}
                    mb={{ base: 0, md: 0 }}
                >
                  <Text as="span" fontWeight="" color="#ffffff">
  Explore your new Kudzu
<span style={{ color: '#30bc89' }}> + </span>
  membership perks
</Text>
                    
                </Text>


                {/* HStack (Button and Close) on the right with margin-right only on desktop */}
                <HStack
                    spacing={{ base: 2, md: 4 }}
                    align="center"
                    mr={{ base: 2, md: 100 }}
                    className="md:mr-10 mr-10"
                >
                    <button type="button"
                        onClick={handleExploreClick}
                   className="text-white text-sm px-3 py-1 rounded-full bg-[#3C66FF] md:bg-gradient-to-r md:from-blue-500 md:to-teal-400 hover:opacity-90 h-auto w-auto md:w-[150px] md:px-5 md:py-2"
                    >
                        <span className="hidden md:inline">Explore</span>
                        <span className="md:hidden">Explore &gt;</span>
                    </button>
                    <button type="button"
                        onClick={handleCloseClick}
                        className="text-sm p-2 hidden md:block"
                    >
                        <img src={closeicon} alt="Close" className="w-4 h-4" />
                    </button>
                </HStack>
            </Flex>
        </Box>
    );
};


export default MembershipBanner;



